import SchoolIcon from 'components/material-symbol/icons/School'
import PeopleOutlineIcon from 'components/material-symbol/icons/PeopleOutline'
import SportsGolfIcon from 'components/material-symbol/icons/SportsGolf'
import TrendingUpIcon from 'components/material-symbol/icons/TrendingUp'
import WorkspacePremiumIcon from 'components/material-symbol/icons/WorkspacePremium'
import SupervisorAccountIcon from 'components/material-symbol/icons/SupervisorAccount'
import EmojiEventsIcon from 'components/material-symbol/icons/EmojiEvents'
import BuildIcon from 'components/material-symbol/icons/Build'
import AccessibleForwardIcon from 'components/material-symbol/icons/AccessibleForward'
import GolfCourseIcon from 'components/material-symbol/icons/GolfCourse'
import StarsIcon from 'components/material-symbol/icons/Stars'
import CelebrationIcon from 'components/material-symbol/icons/Celebration'
import GroupIcon from 'components/material-symbol/icons/Group'

const EXACT_TYPE_ICONS = {
  'Getting Started': SchoolIcon,
  'Having More Fun': CelebrationIcon,
  'Improving Your Game': TrendingUpIcon,
  'Player Type': PeopleOutlineIcon,
  'Session Type': GroupIcon,
}

const ICON_RULES = [
  { pattern: /getting started|beginner|intro/i, icon: SchoolIcon },
  { pattern: /having more fun|more fun|enjoy|social/i, icon: CelebrationIcon },
  {
    pattern: /improving your game|improv|playing better|advanced/i,
    icon: TrendingUpIcon,
  },
  { pattern: /player type|demographic/i, icon: PeopleOutlineIcon },
  { pattern: /session type/i, icon: GroupIcon },
  { pattern: /junior|youth|teen/i, icon: SupervisorAccountIcon },
  { pattern: /business|corporate|network/i, icon: WorkspacePremiumIcon },
  { pattern: /skill|skill level/i, icon: TrendingUpIcon },
  { pattern: /tournament|competitive/i, icon: EmojiEventsIcon },
  { pattern: /club|fitting|equipment|tool/i, icon: BuildIcon },
  { pattern: /adaptive|disabilit/i, icon: AccessibleForwardIcon },
  { pattern: /course|on-course|playing lesson/i, icon: GolfCourseIcon },
  { pattern: /service|lesson|coaching/i, icon: SportsGolfIcon },
]

export const getSelectionGroupIcon = typeName => {
  if (!typeName) {
    return StarsIcon
  }

  if (EXACT_TYPE_ICONS[typeName]) {
    return EXACT_TYPE_ICONS[typeName]
  }

  const match = ICON_RULES.find(({ pattern }) => pattern.test(typeName))
  return match?.icon || StarsIcon
}
